export default __webpack_public_path__ + "static/media/35.10c8b80f.svg";